<template>
  <v-app>
    <app-header />

    <app-bar app />

    <v-main class="mb-4 white">
      <router-view
        class="animate__animated animate__slideInLeft animate__faster"
      ></router-view>
    </v-main>

    <footer-nav />
  </v-app>
</template>

<script>
import AppBar from "@/components/nav/AppBar";
import FooterNav from "@/components/nav/FooterNav";
import AppHeader from "@/components/AppHeader";

export default {
  name: "app",

  components: {
    AppBar,
    AppHeader,
    FooterNav,
  },

  mounted() {
    if (window.scrollY > 172) {
      this.$store.commit("ui/appBarTrue");
    }
  },

  computed: {
    appBar() {
      return this.$store.state.appBar;
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Amaranth:700|Anton|Kanit:700|Libre+Baskerville&display=swap");

@font-face {
  font-family: "DayPosterBlack";
  src: url("/font/DAYPBL__-webfont.woff") format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "EckhardtPosterItalicJNL";
  src: url("/font/3AEE99_0_0.eot");
  src: url("/font/3AEE99_0_0.eot?#iefix") format("embedded-opentype"),
    url("/font/3AEE99_0_0.woff2") format("woff2"),
    url("/font/3AEE99_0_0.woff") format("woff"),
    url("/font/3AEE99_0_0.ttf") format("truetype");
  font-display: swap;
}

body,
.v-application {
  font-family: "Libre Baskerville", "Kanit", "Roboto", "Arial", sans-serif !important;
}

.popup-heading {
  font-family: "DayPosterBlack", cursive;
  font-size: 34px;
  letter-spacing: 4px;
  text-shadow: -4px 4px #002156;
  transform: scaleY(1.2);
  text-transform: uppercase;
  color: #ffe001;
}

.popup-title {
  font-size: 1.25rem !important;
  font-family: "EckhardtPosterItalicJNL";
  color: #ffe001;
  letter-spacing: 0.25rem;
}

.v-content {
  background-color: #ed3825;
}

/* Ribbon */
.corner-ribbon {
  width: 200px;
  background: #002156;
  position: absolute;
  top: 25px;
  right: -50px;
  left: auto;
  font-family: "EckhardtPosterItalicJNL";
  text-align: center;
  line-height: 2rem;
  letter-spacing: 1px;
  color: #f0f0f0;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
}
</style>
